import { useGatesMepStore } from 'vue_features/gates_mep/composables/use_gates_mep_store'

export default function ({ state }) {
  useGatesMepStore().$set(state)

  return {}
}
